class TrPriceRange extends HTMLElement {
  selectors = {
    minimumInput: '[data-tr-js-price-range-minimum-input]',
    maximumInput: '[data-tr-js-price-range-maximum-input]',
    minimumValue: '[data-tr-js-price-range-minimum]',
    maximumValue: '[data-tr-js-price-range-maximum]',
    selectedTrack: '[data-tr-js-price-range-selected-track]',
  };

  connectedCallback() {
    this.minimumRangeInputElement = this.querySelector(this.selectors.minimumInput);
    this.maximumRangeInputElement = this.querySelector(this.selectors.maximumInput);
    this.minimumValueElement = this.querySelector(this.selectors.minimumValue);
    this.maximumValueElement = this.querySelector(this.selectors.maximumValue);
    this.selectedTrackElement = this.querySelector(this.selectors.selectedTrack);
    this.minimumFieldInputElement = document.getElementById(this.dataset.minimumInputId);
    this.maximumFieldInputElement = document.getElementById(this.dataset.maximumInputId);

    this.init();
    this.bindEvents();
  }

  disconnectedCallback() {
    this.destroy();
  }

  init() {
    this.updateRange();
  }

  bindEvents() {
    this.minimumRangeInputElement.addEventListener('input', this.onMinimumInput);
    this.maximumRangeInputElement.addEventListener('input', this.onMaximumInput);
  }

  onMinimumInput = () => {
    if (Number(this.minimumRangeInputElement.value) > Number(this.maximumRangeInputElement.value)) {
      this.minimumRangeInputElement.value = this.maximumRangeInputElement.value;
    }

    this.updateRange();
    this.updateFilterInputs();
  };

  onMaximumInput = () => {
    if (Number(this.maximumRangeInputElement.value) < Number(this.minimumRangeInputElement.value)) {
      this.maximumRangeInputElement.value = this.minimumRangeInputElement.value;
    }

    this.updateRange();
    this.updateFilterInputs();
  };

  updateRange() {
    const minimumValue = Number(this.minimumRangeInputElement.value);
    const maximumValue = Number(this.maximumRangeInputElement.value);
    const rangeMaximum = Number(this.dataset.rangeMaximum);
    const minimumPosition = (minimumValue / rangeMaximum) * 100;
    const maximumPosition = (maximumValue / rangeMaximum) * 100;

    this.minimumValueElement.textContent = this.formatCurrency(minimumValue);
    this.maximumValueElement.textContent = this.formatCurrency(maximumValue);
    this.selectedTrackElement.style.left = `${minimumPosition}%`;
    this.selectedTrackElement.style.right = `${100 - maximumPosition}%`;
  }

  updateFilterInputs() {
    this.minimumFieldInputElement.value = this.minimumRangeInputElement.value;
    this.maximumFieldInputElement.value = this.maximumRangeInputElement.value;
    this.maximumFieldInputElement.dispatchEvent(new Event('input', { bubbles: true }));
  }

  formatCurrency(value) {
    return new Intl.NumberFormat(document.documentElement.lang, {
      style: 'currency',
      currency: this.dataset.currencyCode,
    }).format(value);
  }

  destroy() {
    this.minimumRangeInputElement.removeEventListener('input', this.onMinimumInput);
    this.maximumRangeInputElement.removeEventListener('input', this.onMaximumInput);
  }
}

customElements.define('tr-price-range', TrPriceRange);
